import Form, { FormProps } from "../../ui-components/forms/form/Form";
import { CreateAssetCollectionFormTextProps } from "./TypedFormTextField";

export type TypedFormProps = CreateAssetCollectionFormTextProps;

export const CreateAssetCollectionTypedForm: (
  props: FormProps<TypedFormProps>
) => JSX.Element = props => Form<TypedFormProps>(props);
